// extracted by mini-css-extract-plugin
export var headerCell = "_12-1";
export var loadingSpinnerContainer = "_12-4";
export var rowWrapper = "_12-3";
export var standaloneTable = "_12-5";
export var table = "_12-0";
export var white = "_12-2";